export enum TimeStatus {
  FUTURE = 'future',
  PRESENT = 'present',
  PAST = 'past',
  UNKNOWN = 'unknown',
}
